import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PermMediaIcon(props: IconProps) {
    return <Icon {...props} iconKey={"perm_media"}/>
}
